import { render, staticRenderFns } from "./SideOrderTemplate.vue?vue&type=template&id=3fa78350&scoped=true"
import script from "./SideOrderTemplate.vue?vue&type=script&lang=js"
export * from "./SideOrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./SideOrderTemplate.vue?vue&type=style&index=0&id=3fa78350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa78350",
  null
  
)

export default component.exports